import React, { useEffect, useState } from 'react';
import styles from '../formStyles.module.css';
import Button from '@/components/common/Button';
import Api from '@/api';
import Level1 from './Level1';
import { useLayoutContext } from '@/context/LayoutContext';
import { useTranslations } from 'next-intl';
import config, { TRIGGERS } from '@/api/global';
import SignupCode from './SignupCode';
import { Pill } from '@/components/general/Pill';
import { maskMobileNumber } from '@/functions/maskMobileNumber';
import isValidMobile from '@/functions/isvalidMobile';
import MainIcons from '@/icons/main';
import { avatarBg } from '@/functions/formats';
import Level3 from './Level3';
import CookieFunction from '@/functions/cookieFunction';
import { useRouter } from 'next/navigation';
import { useRouterPath } from '@/functions/routerPath';

export default function LoginModal({ modalKey, active, setActive }) {
  const { trigger, setTrigger, userInfo, setUserInfo, showError } = useLayoutContext();
  const [loading, setLoading] = useState(false);
  const [loadingCode, setLoadingCode] = useState(false);
  const router = useRouter();
  const routerPath = useRouterPath();
  const tCommon = useTranslations('common');
  const empty = {
    mobile: '',
    code: '',
    error: {
      mobile: false,
      code: false,
    },
    messages: {
      mobile: tCommon('requiredField'),
      code: tCommon('requiredField'),
    },
  };
  const [info, setInfo] = useState(empty);

  const loginSaveInfo = (response) => {
    CookieFunction('set', config.tokenName, response?.token, 365);
    if (response?.default) {
      CookieFunction('set', config.carIdCara, response?.default?.car_id, 365);
      CookieFunction('set', config.userIdCara, response?.default?.sub_user_id, 365);
    }
    CookieFunction('set', config.superUserIdCara, response?.userId, 365);
    // setActive(2);
    setInfo(empty);
    window.location.reload();
  };
  const loginCallConfirmCode = (params, extraParams = {}) => {
    let apiCall = Api.Login({ ...params, ...extraParams });
    setLoading(true);
    apiCall
      .then((res) => {
        const response = res?.data;
        console.log('response====', res);
        setLoading(false);

        if (process.env.two_step_verification == 'true') {
          if (!response.two_step_verification) {
            loginSaveInfo(response);
          } else {
            if (active == 2) {
              onChange('', 'code');
              setActive(3);
            }
          }
        } else {
          loginSaveInfo(response);
        }
      })
      .catch((err) => {
        setLoading(false);
        showError(err);
      });
  };

  const handleSubmit = (code = null) => {
    let check = checkError();
    console.log('check==', check);
    // if (active != 3) {
    if (!check && !loading) {
      const params = {
        mobile: info?.mobile,
        code: code ? code : info?.code,
      };

      // setActive(active + 1);
      if (active == 1) {
        let apiCall = Api.sendCode(params);
        setLoading(true);
        apiCall
          .then((res) => {
            setLoading(false);
            setActive(active + 1);
          })
          .catch((err) => {
            setLoading(false);
            showError(err);
          });
      }
      if (active == 2) {
        loginCallConfirmCode(params);
      }
      if (active == 3 && process.env.two_step_verification == 'true') {
        loginCallConfirmCode(params, { two_step_verification: true });
      }
    }
    // } else {
    //   setTrigger(TRIGGERS.EMPTY);
    //   setActive(1);
    //   setInfo(empty);
    //   window.location.reload();
    // }
  };
  const checkError = (sendCode = false) => {
    let dummy = { ...info };
    let result = false;
    let values = ['code', 'mobile'];

    if (active == 1) {
      values = ['mobile'];
    }
    if (active == 2) {
      values = ['code'];
    }
    if (sendCode) {
      values = ['mobile'];
    }

    values?.map((item, i) => {
      if (String(info?.[item])?.trim()?.length == 0) {
        dummy.error[item] = true;
        dummy.messages[item] = tCommon('requiredField');
        result = true;
      }
      if (item == 'mobile') {
        console.log('mobile==============', isValidMobile(info?.['mobile']));
        if (!isValidMobile(info?.['mobile']) && String(info?.[item])?.trim()?.length != 0) {
          dummy.error[item] = true;
          dummy.messages[item] = 'شماره موبایل معتبر نیست';
          result = true;
        }
      }
    });

    setInfo({ ...dummy });
    return result;
  };
  const onChange = (value, key) => {
    let valueIs = {
      ...info,
      [key]: value,
      error: {
        ...info?.error,
        [key]: false,
      },
    };
    if (key == 'mobile') {
      valueIs.mobile = valueIs?.mobile?.startsWith('0')
        ? valueIs?.mobile.slice(1)
        : valueIs?.mobile;
    }

    setInfo(valueIs);
  };
  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSubmit();
    }
  };
  const sendCodeFunction = () => {
    setInfo({ ...info, code: '' });
    const hasError = checkError(true);

    if (hasError) {
      return Promise.reject(new Error('Validation failed'));
    }

    if (!hasError) {
      console.log('h', hasError);
      setLoadingCode(true);
      let extraParams = { mobile: info?.mobile };
      if (process.env.two_step_verification == 'true' && active == 3) {
        extraParams = { ...extraParams, two_step_verification: true };
      }
      return Api.sendCode(extraParams)
        .then((res) => {
          setLoadingCode(false);
          return res;
        })
        .catch((err) => {
          console.log('has========', err);
          setLoadingCode(false);
          showError(err);
          throw err; // <-- IMPORTANT
        });
    }
  };

  const onComplete = (code) => {
    handleSubmit(code);
  };
  return (
    <div className={`${styles.container} ${styles.addressFormContainer}`}>
      {/* {active != 3 && (
        <p className={`${styles.modalText}`}>برای ورود، شمارهٔ تلفن همراه خود را وارد نمایید</p>
      )} */}
      {active == 1 && (
        <>
          <p className={`${styles.modalText}`}>برای ورود، شمارهٔ تلفن همراه خود را وارد نمایید</p>
          <Level1
            info={info}
            setInfo={setInfo}
            modalKey={modalKey}
            onChange={onChange}
            onKeyDown={onKeyDown}
          />
        </>
      )}
      {active == 2 && (
        <
          // div
          // className={`${styles.formContainer} ${styles.formContainerGrid1} ${styles.formAutoHeight}`}
        >
          {/* <Pill color="var(--gray)" bg={avatarBg(6)} className={`${styles.pill}`}>
            کد تایید به شماره
            <span style={{ color: 'var(--brand-deep)' }}> {maskMobileNumber(info?.mobile)}</span>
            ارسال شد
          </Pill> */}
          <p className={`${styles.modalText}`}>
            کد تایید به شماره
            <span style={{ color: 'var(--brand-deep)', fontWeight: 'bold', margin: '0 4px' }}>
              {' '}
              {maskMobileNumber(info?.mobile)}
            </span>
            ارسال شد
          </p>
          <SignupCode
            length={4}
            onKeyDown={onKeyDown}
            onChange={onChange}
            sendCodeFunction={sendCodeFunction}
            info={info}
            setInfo={setInfo}
            loading={loadingCode}
            onComplete={onComplete}
          />
        </>
      )}
      {active == 3 && process.env.two_step_verification == 'true' && (
        <>
          <p className={`${styles.modalText}`}>کد تایید به ایمیل حساب کاربری شما ارسال شد</p>
          <SignupCode
            length={4}
            onKeyDown={onKeyDown}
            onChange={onChange}
            sendCodeFunction={sendCodeFunction}
            info={info}
            setInfo={setInfo}
            loading={loadingCode}
            onComplete={onComplete}
          />
        </>
      )}
      {/* {active == 3 && <Level3 />} */}

      <Button
        onClick={() => handleSubmit()}
        className={`btn btn-primary w-full squareButton ${styles.submitButton}`}
        wrapperStyle={`w-full`}
        loading={loading}
        showAnimation={false}
      >
        {active == 1 && 'دریافت کد تایید'}
        {active == 2 && 'ورود به حساب کاربری'}
        {active == 3 && 'ورود به حساب کاربری'}

        {/* {active == 3 && 'بستن'} */}
      </Button>
      {/* {active == 2 && (
        <div
          className={`${styles.editMobile}`}
          onClick={() => {
            setActive(active - 1);
          }}
        >
          <MainIcons.arrowIcon width="16px" height="16px" />
          اصلاح شماره تلفن
        </div>
      )} */}
    </div>
  );
}
